export const GET_EVENTS_LEADERBOARD_LIST ="GET_EVENTS_LEADERBOARD_LIST";
export const SET_CURRENT_QUES_ID ="SET_CURRENT_QUES_ID";
export const GET_QUES_LEADERBOARD_LIST ="GET_QUES_LEADERBOARD_LIST";
export const SET_LEADERBOARD_LIST ="SET_QUES_LEADERBOARD_LIST";
export const SET_EDIT_LEADER_BOARD_LIST ="SET_EDIT_LEADER_BOARD_LIST";
export const SET_LEADERBOARD_EVENTS ="SET_LEADERBOARD_EVENTS";
export const SET_LEADERBOARD_QUESTIONS ="SET_LEADERBOARD_QUESTIONS";
export const SET_EDIT_LEADER_BOARD_QUESTION_DATA ="SET_EDIT_LEADER_BOARD_QUESTION_DATA";
export const SET_DROPDOWN_QUESTIONS_LIST ="SET_DROPDOWN_QUESTIONS_LIST";
export const SET_IS_GET_EVENTS_LEADERBOARD_LISTS_PENDING= "SET_IS_GET_EVENTS_LEADERBOARD_LISTS_PENDING";
export const SET_IS_GET_QUESTIONS_LEADERBOARD_LISTS_PENDING= "SET_IS_GET_QUESTIONS_LEADERBOARD_LISTS_PENDING";
export const SET_IS_GET_DROPDOWN_QUESTIONS_LIST_PENDING= "SET_IS_GET_DROPDOWN_QUESTIONS_LIST_PENDING";
export const SET_CONTINOUS_EVALUATE_PENDING = "SET_CONTINOUS_EVALUATE_PENDING";
export const SET_IS_EDIT_LEADERBOARD_PENDING = "SET_IS_EDIT_LEADERBOARD_PENDING";
export const SET_LOCK_EDITING_PENDING = "SET_LOCK_EDITING_PENDING";
export const SET_CURRENT_QUESTION_ID = "SET_CURRENT_QUESTION_ID";
export const SET_UNLOCK_EDITING_PENDING = "SET_UNLOCK_EDITING_PENDING";

